import {
  EWebinarSetGroup,
  HomePageSetFragment,
  MeFragment,
  MyRole,
  SeriesFragment,
} from '$/GraphQL/schema/schema';

export const getSortedPublishedSets = (sets?: HomePageSetFragment[]): HomePageSetFragment[] => {
  if (!sets) return [];

  return sets
    .filter((set) => set.group === EWebinarSetGroup.Published)
    .sort((a, b) => {
      return a.title.localeCompare(b.title);
    });
};

export const getAllSetsGroupedAndSorted = (
  sets: HomePageSetFragment[],
  series: SeriesFragment[],
  me: MeFragment
): (HomePageSetFragment | SeriesFragment | { header: string })[] => {
  if (!sets) return [];
  let setsCopy = [...sets];
  if (me.inTeam.role === MyRole.Moderator) {
    setsCopy = setsCopy.filter(
      (set) =>
        set.group === EWebinarSetGroup.Published &&
        set.set.assignedModerators.some((mod) => mod.id === me.id)
    );
  }

  const seriesSets = setsCopy.filter((set) => set.set.series);
  const webinarSets = setsCopy.filter((set) => !set.set.series);

  const publishedSets = webinarSets
    .filter((set) => set.group === EWebinarSetGroup.Published)
    .sort((a, b) => {
      return a.title.localeCompare(b.title);
    });

  const draftSets = webinarSets
    .filter((set) => set.group === EWebinarSetGroup.Draft)
    .sort((a, b) => {
      return a.title.localeCompare(b.title);
    });

  const seriesHasDrafts = seriesSets.some((set) => !set.set.publicWebinar);
  const seriesHasPublished = seriesSets.some((set) => set.set.publicWebinar);

  return [
    ...(series.length > 0 ? [{ header: 'Webinar series ' }] : []),
    ...series
      .map((series) => {
        return [
          series,
          ...seriesSets
            .filter((set) => set.set.series?.id === series.id)
            .sort((a, b) => (a.set.seriesOrder ?? 0) - (b.set.seriesOrder ?? 0)),
        ];
      })
      .flat(),
    ...(publishedSets.length > 0
      ? [{ header: seriesHasPublished ? 'Other published webinars' : 'Published webinars' }]
      : []),
    ...publishedSets,
    ...(draftSets.length > 0
      ? [{ header: seriesHasDrafts ? 'Other draft webinars' : 'Draft webinars' }]
      : []),
    ...draftSets,
  ];
};
